module.exports = __webpack_public_path__ + "img/logo.827a5373.png";